module.exports = {"530721101":"黄山镇","530721102":"石鼓镇","530721103":"巨甸镇","530721104":"白沙镇","530721105":"拉市镇","530721106":"奉科镇","530721107":"鸣音镇","530721203":"太安乡","530721204":"龙蟠乡","530721205":"黎明傈僳族乡","530721206":"鲁甸乡","530721207":"塔城乡","530721208":"大具乡","530721209":"宝山乡","530721212":"石头白族乡","530721213":"九河白族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530721.json
// module id = 2592
// module chunks = 0